'use client';

import { useState } from 'react';

import { ELButton, ELRadioButton, ELSelect } from '@davincihealthcare/elty-design-system-react';
import { XMarkIcon } from '@heroicons/react/24/outline';

import Modal from '@/app/_components/modal';

type Props = {
  selectedDoctorId: string | undefined;
  selectDoctorOptions: { id: string | undefined; value: string }[];
  onAcceptSelection: (doctorId: string | undefined) => void;
};

export const SelectDoctorForTabletAndSmaller = ({ selectedDoctorId, selectDoctorOptions, onAcceptSelection }: Props) => {
  const [selectedOptionId, setSelectedOptionId] = useState<string | undefined>(selectedDoctorId);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const closeModal = (resetSelectedOptionId: boolean = true) => {
    resetSelectedOptionId && setSelectedOptionId(selectedDoctorId);

    setIsModalOpen(false);
  };

  return (
    <div className="flex flex-col gap-1">
      <ELSelect
        name="doctors"
        label="Professionista sanitario"
        options={[]}
        onClick={() => setIsModalOpen(true)}
        placeholder={selectDoctorOptions.find(opt => opt.id === selectedDoctorId)?.value ?? 'Seleziona un medico'}
        data-cy="doctors-select-mobile"
      />

      {isModalOpen && (
        <Modal
          className="absolute mb-0 ml-auto flex h-[60%] w-full max-w-full flex-col items-center justify-between gap-4 rounded-t-xl"
          onClose={() => closeModal()}
          isModalOpen
        >
          <div className="flex h-full w-full flex-col bg-gray-50 px-5 pb-11 pt-5">
            {/* Fixed Header */}
            <header className="flex flex-shrink-0 items-center justify-between pb-4">
              <div className="w-6" />
              <h2 className="font-semibold text-primary">Professionista sanitario</h2>
              <button className="focus:outline-none" onClick={() => closeModal()} aria-label="Chiudi">
                <XMarkIcon className="h-6 w-6" />
              </button>
            </header>

            {/* Scrollable List */}
            <div className="flex-1 overflow-y-auto">
              <div className="flex flex-col">
                {selectDoctorOptions.map((option, idx) => (
                  <div
                    key={option.id + option.value}
                    className={`flex py-4 ${idx !== selectDoctorOptions.length - 1 && 'border-b border-neutral-surface'}`}
                  >
                    <ELRadioButton
                      name={`radio_button_${option.id || 'all'}`}
                      aria-label={option.value}
                      label={option.value}
                      checked={selectedOptionId === option.id}
                      onChange={() => setSelectedOptionId(option.id)}
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Fixed Footer */}
            <footer className="flex flex-shrink-0 flex-col gap-6 pt-7">
              <ELButton
                size="large"
                fullWidth
                variant="outlined"
                color="primary"
                label="Vedi orari"
                onClick={() => {
                  onAcceptSelection(selectedOptionId);
                  closeModal(false);
                }}
              />
              <ELButton
                size="large"
                fullWidth
                variant="text"
                color="primary"
                label="Annulla"
                onClick={() => {
                  closeModal();
                }}
              />
            </footer>
          </div>
        </Modal>
      )}
    </div>
  );
};
